import React from 'react';

import Code from '@atlaskit/code/code';
import { Text } from '@atlaskit/primitives/compiled/text';
import { Table } from '@atlaskit/table/primitives/table';
import { TBody } from '@atlaskit/table/primitives/tbody';
import { TH } from '@atlaskit/table/primitives/th';
import { THead } from '@atlaskit/table/primitives/thead';
import { TR } from '@atlaskit/table/primitives/tr';
import { Cell as TD } from '@atlaskit/table/td';

import HorizontalScrollContainer from '../horizontal-scroll-container';
import CollapsingTopMargin from '../utils/collapsing-top-margin';

interface Breakpoint {
	device: string;
	name: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';
	viewport: string;
	columns: number;
	gutters: string;
	margins: string;
}
const breakpoints: Breakpoint[] = [
	{
		device: 'Mobile',
		name: 'xxs',
		viewport: '320 - 479px',
		columns: 2,
		gutters: 'space.150 (12px)',
		margins: 'space.200 (16px)',
	},
	{
		device: 'Tablet',
		name: 'xs',
		viewport: '480 - 767px',
		columns: 6,
		gutters: 'space.150 (12px)',
		margins: 'space.200 (16px)',
	},
	{
		device: 'Tablet',
		name: 's',
		viewport: '768 - 1023px',
		columns: 6,
		gutters: 'space.150 (12px)',
		margins: 'space.200 (16px)',
	},
	{
		device: 'Desktop',
		name: 'm',
		viewport: '1024 - 1439px',
		columns: 12,
		gutters: 'space.200 (16px)',
		margins: 'space.400 (32px)',
	},
	{
		device: 'Desktop',
		name: 'l',
		viewport: '1440 - 1767px',
		columns: 12,
		gutters: 'space.200 (16px)',
		margins: 'space.400 (32px)',
	},
	{
		device: 'Desktop',
		name: 'xl',
		viewport: '1768+px',
		columns: 12,
		gutters: 'space.200 (16px)',
		margins: 'space.400 (32px)',
	},
];

/**
 * __Breakpoints table__
 */
export const BreakpointsTable = (): React.JSX.Element => {
	return (
		<CollapsingTopMargin>
			<HorizontalScrollContainer>
				<Table>
					<THead>
						<TR isBodyRow={false}>
							<TH>Device</TH>
							<TH>Breakpoint</TH>
							<TH>Viewport</TH>
							<TH>Columns</TH>
							<TH>Gutters</TH>
							<TH>Margins</TH>
						</TR>
					</THead>
					<TBody>
						{breakpoints.map((breakpoint) => {
							return (
								<TR key={breakpoint.name}>
									<TD>
										<Text>{breakpoint.device}</Text>
									</TD>
									<TD>
										<Code>{breakpoint.name}</Code>
									</TD>
									<TD>
										<Text>{breakpoint.viewport}</Text>
									</TD>
									<TD>
										<Text>{breakpoint.columns}</Text>
									</TD>
									<TD>
										<Text>{breakpoint.gutters}</Text>
									</TD>
									<TD>
										<Text>{breakpoint.margins}</Text>
									</TD>
								</TR>
							);
						})}
					</TBody>
				</Table>
			</HorizontalScrollContainer>
		</CollapsingTopMargin>
	);
};
